import PropTypes from 'prop-types';
import './Button.scss';

const Button = ({
  children,
  variant = 'continuation',
  onClick,
  type = 'button',
  disabled = false,
  fullWidth = false,
  className = '',
  ...props
}) => {
  const baseClass = 'btn-component';
  const variantClass = `btn-component--${variant}`;
  const widthClass = fullWidth ? 'btn-component--full-width' : '';
  
  const classes = [
    baseClass,
    variantClass,
    widthClass,
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['cancel', 'continuation', 'previous']),
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

export default Button;
